"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[64898,42609],{

/***/ 43691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$h": function() { return /* binding */ getProductUrl; }
/* harmony export */ });
/* harmony import */ var _teko_slug__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93512);







const getProductUrl = (name, sku) => {
  return `/${(0,_teko_slug__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(name)}--s${sku}?sku=${sku}`;
};




/***/ }),

/***/ 640793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ TabItem; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _Typography_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(621655);
/* harmony import */ var _TabsContext_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(846291);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledBody = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .Body */ .uT)`
  &:hover {
    color: ${(p) => p.activeColor};
  }
`;
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  padding: ${(p) => `${p.theme.spacing.s8} ${p.theme.spacing.s16}`};
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: ${(props) => props.minWidth ? props.minWidth : ""};
  max-width: ${(props) => props.maxWidth ? props.maxWidth : ""};
  background-color: ${(props) => props.isActive ? props.activeBackground : props.background};
  ${(p) => p.fluid ? `
    flex: 1;
  ` : ``}
  flex-direction: ${(p) => p.direction === "horizontal" ? "row" : "column"};
  ${(p) => !p.ignoreSecondChildStyles && `
      > *:nth-child(2) {
        ${p.direction === "horizontal" ? `
          flex: 1;
          margin-left: ${p.theme.spacing.s8};
        ` : `
          line-height: 1.5rem;
          margin-top: ${p.theme.spacing.s4};
        `}
      }
    `}
  &:hover {
    ${(props) => props.type === "line" ? `
      path[stroke],
      rect[stroke],
      line {
        stroke: ${props.theme.colors.primary500};
      }` : ""};
    path:not([stroke]),
    rect:not([stroke]) {
      fill: ${(p) => p.theme.colors.primary500};
    }
    > .tab-title {
      color: ${(p) => p.theme.colors.primary500};
    }
  }
`;
const TabItem = (_a) => {
  var _b = _a, {
    tabId,
    text,
    minWidth,
    maxWidth,
    icon,
    color = "textSecondary",
    activeColor = "primary500",
    background = "white",
    activeBackground = "white",
    direction = "horizontal",
    type,
    className,
    onClick,
    tabTitle
  } = _b, rest = __objRest(_b, [
    "tabId",
    "text",
    "minWidth",
    "maxWidth",
    "icon",
    "color",
    "activeColor",
    "background",
    "activeBackground",
    "direction",
    "type",
    "className",
    "onClick",
    "tabTitle"
  ]);
  const { activeTab, fluid, dispatch, onChange } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_TabsContext_es_js__WEBPACK_IMPORTED_MODULE_3__/* .TabsContext */ .RL);
  const isActive = tabId === activeTab;
  const elementRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (elementRef.current && isActive) {
      onChange(tabId);
      dispatch({
        type: "setDimension",
        payload: {
          dimension: {
            width: elementRef.current.offsetWidth,
            left: elementRef.current.offsetLeft,
            height: elementRef.current.offsetHeight,
            top: elementRef.current.offsetTop
          }
        }
      });
    }
  }, [activeTab, dispatch]);
  const handleClick = () => {
    dispatch({ type: "changeTab", payload: { activeTab: tabId } });
    onClick == null ? void 0 : onClick();
    if (elementRef.current)
      elementRef.current.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "center"
      });
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    isActive,
    background,
    activeBackground,
    color,
    activeColor,
    ref: elementRef,
    onClick: handleClick,
    direction,
    fluid,
    type,
    className,
    minWidth,
    maxWidth,
    ignoreSecondChildStyles: !!tabTitle
  }, rest), icon ? react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(icon, {
    color: isActive ? activeColor : color
  }) : null, text ? isActive ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .SubTitle */ .DK, {
    level: 4,
    color: activeColor,
    line: 1
  }, text) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledBody, {
    level: 1,
    color,
    line: 1,
    activeColor
  }, text) : null, tabTitle && react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(tabTitle, {
    color: isActive ? activeColor : color
  }));
};




/***/ }),

/***/ 517844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ Tabs; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _TabsContext_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(846291);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);
/* harmony import */ var _helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19840);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F}
  position: relative;
  height: 100%;
`;
const TabTitle = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ width, left, theme, type }) => `
    position: relative;
    display: flex;
    align-items: stretch;
    overflow-x: scroll;
    overflow-y: hidden;
    width: 100%;
    ${type === "line" ? `border-bottom: 1px solid ${theme == null ? void 0 : theme.colors.divider};&::after {
      content: ' ';
      height: 2px;
      background-color: ${theme == null ? void 0 : theme.colors.primary500};
      display: inline-block;
      position: absolute;
      transition: all 0.2s ease-out;
      bottom: 0;
      left: ${left}px;
      width: ${width}px;
    }` : ""}
    /* Hide scroll bar */
    -ms-overflow-style: none;
    scrollbar-width: none;
    ::-webkit-scrollbar {
      display: none;
    }


  `);
const Component = (_a) => {
  var _b = _a, {
    children,
    textActiveColor,
    textColor,
    background,
    activeBackground,
    type = "line",
    tabTitleProps
  } = _b, rest = __objRest(_b, [
    "children",
    "textActiveColor",
    "textColor",
    "background",
    "activeBackground",
    "type",
    "tabTitleProps"
  ]);
  var _a2, _b2;
  const {
    dimension: { width, left, top, height },
    activeTab
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_TabsContext_es_js__WEBPACK_IMPORTED_MODULE_3__/* .TabsContext */ .RL);
  const arr = children.filter(_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_4__/* .isNotNullOrUndefinedElement */ .C4);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, rest), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TabTitle, __spreadProps(__spreadValues({}, tabTitleProps), {
    type,
    width,
    left,
    top,
    height
  }), arr.map((item, index) => react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(item, {
    key: index,
    tabId: index,
    color: textColor,
    activeColor: textActiveColor,
    background,
    activeBackground,
    type
  }))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, (_b2 = (_a2 = arr[activeTab]) == null ? void 0 : _a2.props) == null ? void 0 : _b2.children));
};
const withContext = (Component2) => {
  const Comp = (_a) => {
    var _b = _a, {
      fluid = false,
      children,
      defaultTab = 0,
      activeTab = defaultTab
    } = _b, rest = __objRest(_b, [
      "fluid",
      "children",
      "defaultTab",
      "activeTab"
    ]);
    const tabState = (0,_TabsContext_es_js__WEBPACK_IMPORTED_MODULE_3__/* .useTabs */ .YE)(activeTab, fluid);
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TabsContext_es_js__WEBPACK_IMPORTED_MODULE_3__/* .TabsProvider */ .X, __spreadValues({}, tabState), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, __spreadValues({}, rest), children));
  };
  return Comp;
};
const Tabs = withContext(Component);




/***/ }),

/***/ 846291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RL": function() { return /* binding */ TabsContext; },
/* harmony export */   "X": function() { return /* binding */ TabsProvider; },
/* harmony export */   "YE": function() { return /* binding */ useTabs; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);


var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultValue = {
  activeTab: 0,
  fluid: false,
  dimension: {
    left: 0,
    width: 0,
    top: 0,
    height: 0
  },
  dispatch: (_) => {
  },
  onChange: (_) => {
  }
};
const reducer = (state, action) => {
  var _a, _b;
  switch (action.type) {
    case "changeTab":
      return __spreadProps(__spreadValues({}, state), {
        activeTab: (_a = action.payload.activeTab) != null ? _a : state.activeTab
      });
    case "setDimension":
      return __spreadProps(__spreadValues({}, state), {
        dimension: (_b = action.payload.dimension) != null ? _b : state.dimension
      });
    default:
      return state;
  }
};
const useTabs = (defaultTab, fluid) => {
  const [state, dispatch] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(reducer, __spreadProps(__spreadValues({}, defaultValue), {
    fluid,
    activeTab: defaultTab
  }));
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    onChangeTab(defaultTab);
  }, [defaultTab]);
  const onChangeTab = (tabId) => {
    dispatch({ type: "changeTab", payload: { activeTab: tabId } });
  };
  return __spreadProps(__spreadValues({}, state), { onChange: onChangeTab, dispatch });
};
const TabsContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(defaultValue);
const TabsProvider = (_a) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TabsContext.Provider, {
    value: __spreadValues({}, props)
  }, children);
};




/***/ }),

/***/ 767535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ FireFlashsaleColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const FireFlashsaleColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M11.8903 0.644C10.0379 1.936 8.46667 3.909 7.58667 6.007C6.99487 5.972 6.4 6.085 5.85128 6.349C3.84308 7.297 2.12923 9.737 2.00923 13.781C2.00205 13.871 2 14.01 2 14.249C2 19.628 6.48308 23.999 12 23.999C17.5292 23.984 22 19.621 22 14.249C22 14.108 21.9928 13.956 21.9815 13.755C21.9774 13.695 21.9774 13.695 21.9744 13.637C21.9662 13.509 21.9579 13.394 21.9518 13.309C21.7426 10.656 20.8462 8.735 19.1744 6.488C19.0472 6.316 18.9477 6.185 18.7292 5.898C18.3662 5.422 18.2174 5.223 18.0554 4.991C17.5467 4.264 17.3846 3.856 17.3846 3.376C17.3846 2.111 16.6595 0.955 15.5097 0.376C15.0103 0.124 14.4667 0 13.9231 0C13.2072 0 12.4944 0.216 11.8903 0.644Z",
          fill: "white"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M13.6997 3.07C12.0013 4.256 10.5848 6.253 10.0884 8.158C9.74484 9.485 9.69971 10.976 9.69356 11.962C8.12433 11.635 7.76946 9.347 7.76535 9.323C7.74792 9.204 7.67407 9.1 7.56535 9.044C7.45561 8.988 7.3274 8.984 7.21664 9.037C7.13458 9.076 5.19817 10.036 5.08535 13.867C5.07715 13.995 5.07715 14.122 5.07715 14.249C5.07715 17.971 8.18279 20.999 12.0002 20.999C15.8279 20.989 18.9233 17.965 18.9233 14.249C18.9233 14.062 18.8833 13.538 18.8833 13.538C18.672 10.854 17.39 9.172 16.2597 7.688C15.2125 6.313 14.3079 5.126 14.3079 3.376C14.3079 3.235 14.2269 3.106 14.0997 3.042C14.0433 3.014 13.9828 3 13.9223 3C13.8433 3 13.7654 3.024 13.6997 3.07Z",
          fill: "#F4811F"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M11.6372 13.206C11.4454 13.985 11.4311 14.847 11.4311 15.595C11.4311 15.885 11.19 16.12 10.8916 16.12C9.98492 16.12 9.42594 15.518 9.11415 14.864C8.94697 15.219 8.79517 15.751 8.77363 16.532C8.76953 16.609 8.76953 16.673 8.76953 16.736C8.76953 18.587 10.2188 20.091 12.0003 20.091C13.7818 20.091 15.2311 18.587 15.2311 16.736C15.2311 16.638 15.2239 16.548 15.2177 16.458C15.1049 14.936 14.4608 14.043 13.8372 13.18C13.4013 12.576 12.9562 11.958 12.7265 11.194C12.2126 11.783 11.8065 12.517 11.6372 13.206Z",
          fill: "#FFD753"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 356026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ GiftFilled; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const GiftFilled = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.25 6.74977H18.4537C18.6345 6.39247 18.7356 6.00019 18.75 5.60002C18.724 4.89259 18.4212 4.22367 17.9068 3.73733C17.3924 3.25098 16.7075 2.98612 15.9998 2.99977C15.1567 3.03608 14.3393 3.30064 13.6349 3.7652C12.9305 4.22976 12.3654 4.8769 12 5.63752C11.6385 4.87902 11.0778 4.23298 10.3776 3.76839C9.67753 3.30381 8.86436 3.03814 8.025 2.99977H7.9395C7.24185 3.00089 6.5718 3.27246 6.07024 3.75738C5.56867 4.2423 5.27465 4.9028 5.25 5.60002V5.64952C5.26463 6.03243 5.36158 6.40769 5.53425 6.74977H3.75C3.55109 6.74977 3.36032 6.82879 3.21967 6.96944C3.07902 7.11009 3 7.30086 3 7.49977V9.74977C3 9.94868 3.07902 10.1394 3.21967 10.2801C3.36032 10.4208 3.55109 10.4998 3.75 10.4998H20.25C20.4489 10.4998 20.6397 10.4208 20.7803 10.2801C20.921 10.1394 21 9.94868 21 9.74977V7.49977C21 7.30086 20.921 7.11009 20.7803 6.96944C20.6397 6.82879 20.4489 6.74977 20.25 6.74977ZM16.023 4.49977C16.3293 4.49182 16.6271 4.60137 16.8552 4.80595C17.0834 5.01053 17.2246 5.29464 17.25 5.60002C17.2394 5.90701 17.1105 6.19802 16.8904 6.41227C16.6703 6.62652 16.3759 6.74744 16.0687 6.74977H13.1085C13.575 5.80552 14.5028 4.49977 16.023 4.49977ZM6.75 5.62477C6.7692 5.31786 6.90549 5.03004 7.13074 4.8207C7.35599 4.61136 7.65301 4.49648 7.9605 4.49977C9.51225 4.50577 10.4213 5.79802 10.893 6.74977H7.968C7.66005 6.75209 7.36276 6.63709 7.13653 6.42813C6.9103 6.21918 6.7721 5.93194 6.75 5.62477ZM13.5 11.9999V20.9999H17.25C17.8467 20.9999 18.419 20.7629 18.841 20.3409C19.2629 19.919 19.5 19.3467 19.5 18.7499V11.9999H13.5ZM4.49999 11.9999H10.5V20.9999H6.74999C6.15325 20.9999 5.58096 20.7629 5.159 20.3409C4.73704 19.919 4.49999 19.3467 4.49999 18.7499V11.9999Z",
          fill: "#A7ABC3"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 309396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ ProductCarouselWithHeader; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(990241);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(212951);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _ProductCarousel_ProductCarousel_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(414562);
/* harmony import */ var _contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(917709);
/* harmony import */ var _BlockHeader_BlockHeader_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(842918);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ProductCarouselWithHeader = (_a) => {
  var _b = _a, {
    header,
    background,
    dividerColor = "rgba(255, 255, 255, 0.5)",
    style,
    tracking,
    backgroundStyle
  } = _b, productCarouselProps = __objRest(_b, [
    "header",
    "background",
    "dividerColor",
    "style",
    "tracking",
    "backgroundStyle"
  ]);
  const { isMobile } = (0,_contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_1__/* .useDevice */ .F)();
  const MOBILE_BG_WIDTH = 856, DESKTOP_BG_WIDTH = 1232;
  const backgroundUrl = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .getImageUrlFromGoogleUserContent */ .Nc)(background, {
    width: isMobile ? MOBILE_BG_WIDTH : DESKTOP_BG_WIDTH
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    style: __spreadValues({
      minHeight: header ? "416px" : "372px"
    }, style)
  }, !!tracking ? tracking : {}), backgroundUrl && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Background, {
    alt: (header == null ? void 0 : header.title) || "",
    src: backgroundUrl,
    width: "100%",
    height: "100%",
    style: backgroundStyle
  }), header && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledBlockHeader, __spreadProps(__spreadValues({}, header), {
    borderColor: dividerColor
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledProductCarousel, __spreadValues({}, productCarouselProps)));
};
ProductCarouselWithHeader.displayName = "ProductCarouselWithHeader";
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].div`
  position: relative;
`;
const Background = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].img`
  position: absolute;
  top: 0;
`;
const StyledProductCarousel = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"])(_ProductCarousel_ProductCarousel_es_js__WEBPACK_IMPORTED_MODULE_4__/* .ProductCarousel */ .G)`
  padding: 12px;
`;
const StyledBlockHeader = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"])(_BlockHeader_BlockHeader_es_js__WEBPACK_IMPORTED_MODULE_5__/* .BlockHeader */ .t)`
  border-bottom: 1px solid ${(props) => props.borderColor};
  .title {
    padding: 0 8px;
  }
`;




/***/ }),

/***/ 732324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ SmallImage; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _EnhancedImage_EnhancedImage_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(788925);




const SmallImage = ({
  image,
  isActive,
  extra,
  onClick,
  onMouseEnter,
  width = 50,
  height = 50,
  borderRadius = 4,
  borderColor = "transparent",
  borderWidth = 1
}) => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    isActive: !!isActive,
    onClick,
    onMouseEnter,
    width,
    height,
    borderRadius,
    borderColor,
    borderWidth
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_EnhancedImage_EnhancedImage_es_js__WEBPACK_IMPORTED_MODULE_1__/* .EnhancedImage */ .N, {
    src: image.src,
    alt: image.alt,
    objectFit: "contain",
    borderRadius,
    width,
    height
  }), extra && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Extra, null, extra));
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"].div(({
  isActive,
  theme,
  width,
  height,
  borderRadius,
  borderColor,
  borderWidth
}) => `
  border-radius: ${typeof borderRadius === "string" ? borderRadius : `${borderRadius}px`};
  border: ${typeof borderWidth === "string" ? borderWidth : `${borderWidth}px`} solid ${isActive ? theme == null ? void 0 : theme.colors.primary500 : borderColor};
  position: relative;
  cursor: pointer;
  width: ${typeof width === "string" ? width : `${width}px`};
  height: ${typeof height === "string" ? height : `${height}px`};
  overflow: hidden;
`);
const Extra = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"].div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;




/***/ }),

/***/ 742609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YoutubeFrame": function() { return /* binding */ YoutubeFrame; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);



const StyledIframe = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_2__["default"].iframe((param)=>{
    let { openInPopup  } = param;
    return "\n    position: relative;\n    height: 100%;\n    width: 100%;\n    pointer-events: ".concat(openInPopup ? "none" : "auto", ";\n");
});
const YoutubeFrame = (param)=>{
    let { embedId , youtubeLink , openInPopup =false  } = param;
    const videoEmbedId = youtubeLink ? getIdFromYoutubeLink(youtubeLink) : embedId;
    if (!videoEmbedId) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledIframe, {
        src: "https://www.youtube.com/embed/".concat(videoEmbedId),
        allowFullScreen: true,
        frameBorder: "0",
        openInPopup: openInPopup
    });
};
const getIdFromYoutubeLink = (url)=>{
    if (!url) return "";
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[7].length == 11 ? match[7] : "";
};


/***/ }),

/***/ 739069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B1": function() { return /* binding */ getComboImageUrl; },
/* harmony export */   "Ou": function() { return /* binding */ flattenPromotionsFromPromotionGroups; },
/* harmony export */   "av": function() { return /* binding */ getItemLinkObj; },
/* harmony export */   "fq": function() { return /* binding */ getCartTitle; },
/* harmony export */   "gw": function() { return /* binding */ getComboLineItems; },
/* harmony export */   "iJ": function() { return /* binding */ getComboPromotionId; },
/* harmony export */   "lL": function() { return /* binding */ getConditionProductLinkObj; }
/* harmony export */ });
/* harmony import */ var _teko_cart_v2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891004);
/* harmony import */ var _teko_discovery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43691);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(634655);




/**
 * Returns all promotions (not being grouped)
 *
 * @returns all promotions
 * @param promotionGroups: list of promotion groups (from API response)
 */ const flattenPromotionsFromPromotionGroups = (promotionGroups)=>{
    return promotionGroups.reduce((pre, param)=>{
        let { promotions: promotionGroup  } = param;
        return [
            ...pre,
            ...promotionGroup
        ];
    }, []) || [];
};
/**
 * Extract all sku and quantity of childItems
 *
 * @returns array of childItems sku and quantity
 * @param childItems - array of item
 * @param productQuantity - combo's quantity
 */ const getComboLineItems = (childItems, productQuantity)=>{
    // get 1 level only
    return childItems.map((product)=>({
            sku: product.sku,
            quantity: product.quantity / productQuantity
        }));
};
/**
 * Return the main promotionId of a combo products
 *
 * @returns the id of the first promotion
 * @param promotionGroups: list of promotion groups (from API response)
 */ const getComboPromotionId = (promotionGroups)=>{
    // all promotions of an item (not being grouped)
    const allItemPromotions = flattenPromotionsFromPromotionGroups(promotionGroups);
    return !!allItemPromotions.length ? allItemPromotions[0].promotionId : 0;
};
/**
 * Returns the link object with the item information
 * Note: only return link when this item's allowedUserAction contains OPEN_PRODUCT_DETAIL value
 *
 * @param item (CartItem)
 * @returns The link Object
 *
 */ const getItemLinkObj = (item)=>{
    if (!item.allowedUserActions || !item.allowedUserActions.includes(_teko_cart_v2__WEBPACK_IMPORTED_MODULE_0__/* .AllowedUserActionItem.OPEN_PRODUCT_DETAIL */ .rV.OPEN_PRODUCT_DETAIL)) return null;
    return {
        as: (0,_teko_discovery__WEBPACK_IMPORTED_MODULE_1__/* .getProductUrl */ .$h)(item.name, item.sku),
        href: {
            pathname: "/products/[sku]",
            query: {
                sku: item.sku
            }
        },
        passHref: true
    };
};
/**
 * Returns the link object with the condition product information
 *
 * @param item (IConditionProduct)
 * @returns The link Object
 *
 */ const getConditionProductLinkObj = (item)=>{
    return {
        as: (0,_teko_discovery__WEBPACK_IMPORTED_MODULE_1__/* .getProductUrl */ .$h)(item.name, item.sku),
        href: {
            pathname: "/products/[sku]",
            query: {
                sku: item.sku
            }
        },
        passHref: true
    };
};
/**
 * return cart title base on orderId and isClone properties
 * @param orderId
 * @param isClone
 * @returns
 */ const getCartTitle = (orderId, isClone, numberOfItems)=>{
    // case checkout new order
    if (!orderId) {
        return "".concat((0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("Giỏ h\xe0ng"), " (").concat(numberOfItems, ")");
    }
    // case clone order
    if (isClone) {
        return (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("Giỏ h\xe0ng (copy đơn {{orderId}})", {
            orderId
        });
    }
    // case edit order
    return (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("Sửa đơn h\xe0ng {{orderId}}", {
        orderId
    });
};
const getComboImageUrl = (childItems)=>{
    if (childItems.length === 0) return [];
    return childItems.map((item)=>item.imageUrl || "");
};


/***/ }),

/***/ 906825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ useGetPriceDetailPage; }
/* harmony export */ });
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(420577);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(643015);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(534924);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(859676);



const useGetPriceDetailPage = ()=>{
    const { cartServiceV2  } = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useServices */ .Su)();
    const { payloadAddToCart  } = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useProductDetailState */ .W)();
    const { data: calculatePrice  } = (0,swr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)([
        "/calculatePrice",
        payloadAddToCart === null || payloadAddToCart === void 0 ? void 0 : payloadAddToCart.sku
    ], async ()=>{
        try {
            if (!(payloadAddToCart === null || payloadAddToCart === void 0 ? void 0 : payloadAddToCart.sku)) return undefined;
            return await cartServiceV2.calculatePrice({
                sku: payloadAddToCart.sku,
                quantity: 1
            });
        } catch (e) {
            _teko_log__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .k.error("Error occur when fetching calculatePrice: ".concat(e));
            return undefined;
        }
    }, {
        revalidateOnFocus: false
    });
    return {
        calculatePrice
    };
};


/***/ }),

/***/ 693442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* binding */ DefaultPromotions; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/GiftFilled.es.js
var GiftFilled_es = __webpack_require__(356026);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Shape/index.es.js
var index_es = __webpack_require__(425336);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var Typography_index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Image/Image.es.js
var Image_es = __webpack_require__(587021);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
;// CONCATENATED MODULE: ./assets/default-promotion.svg
/* harmony default export */ var default_promotion = ("https://shopfront-cdn.tekoapis.com/_next/static/images/default-promotion-30ac7917388f7e0e58dcff2420e2c830.svg");
// EXTERNAL MODULE: ../../.yarn/cache/dompurify-npm-2.3.6-0bc101c0e7-4b2bbf6bc6.zip/node_modules/dompurify/dist/purify.js
var purify = __webpack_require__(391547);
var purify_default = /*#__PURE__*/__webpack_require__.n(purify);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
;// CONCATENATED MODULE: ./modules/product-detail/shared/DefaultPromotions.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  padding-left: 0; // remove default padding of ul\n  margin: 0;\n  margin-left: 2rem;\n  img {\n    height: 20px;\n    width: 20px;\n    border-radius: 4px;\n    border: 1px solid #0000000f;\n    object-fit: contain;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: -12px;\n  left: 8px;\n  z-index: 1;\n  width: max-content;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  border-radius: 0.25rem;\n  padding: 2px 10px 2px 10px;\n  background: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







const DefaultPromotions = (props)=>{
    const { promotions  } = props;
    const { epicOmni1643  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, {
        padding: [
            "s8",
            "s0"
        ],
        backgroundColor: "white",
        marginTop: epicOmni1643 ? "s12" : "s0",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RelativeWrapper, {
            children: [
                epicOmni1643 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLabel, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GiftFilled_es/* GiftFilled */.p, {
                            size: 20,
                            color: "white"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Caption */.YS, {
                            level: 1,
                            weight: "medium",
                            color: "white",
                            children: (0,i18n.t)("Bạn sẽ nhận được")
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, {
                    paddingLeft: "s8",
                    style: {
                        marginBottom: -15
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_es/* Image */.E, {
                        src: default_promotion,
                        width: "140px",
                        height: "24px"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PromotionsWrapper, {
                    epicOmni1643: epicOmni1643,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledUl, {
                        children: promotions.map((promotion, index)=>{
                            var ref, ref1;
                            // tier promotions will have no title
                            return !!promotion.title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_index_es/* Body */.uT, {
                                    weight: "regular",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            dangerouslySetInnerHTML: {
                                                __html: ((purify_default()) === null || (purify_default()) === void 0 ? void 0 : (ref = (purify_default()).sanitize) === null || ref === void 0 ? void 0 : ref.call((purify_default()), promotion.title)) || promotion.title
                                            },
                                            style: {
                                                whiteSpace: "pre-line"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                                            weight: "regular",
                                            color: "#F89E33",
                                            children: (ref1 = promotion.highlightedDescriptions) === null || ref1 === void 0 ? void 0 : ref1[0]
                                        })
                                    ]
                                })
                            }, "".concat(index).concat(promotion.promotionId)) : null;
                        })
                    })
                })
            ]
        })
    });
};
const RelativeWrapper = emotion_styled_browser_esm["default"].div(_templateObject());
const PromotionsWrapper = (0,emotion_styled_browser_esm["default"])(index_es/* Shape */.b)((param)=>{
    let { epicOmni1643 , theme  } = param;
    return "\n  padding: 16px 8px;\n  padding-top: 24px;\n  background: ".concat(!epicOmni1643 ? "linear-gradient(180deg,rgba(250, 225, 76, 0.1) 4.81%,rgba(250, 225, 76, 0) 100%)" : theme.colors.secondary100, ";\n  border:  ").concat(!epicOmni1643 ? "1px solid #ffd591" : "none", ";\n  border-radius: 8px;\n");
});
const StyledUl = emotion_styled_browser_esm["default"].ul(_templateObject1());
const StyledLabel = emotion_styled_browser_esm["default"].div(_templateObject2(), (param)=>{
    let { theme  } = param;
    return theme.colors.primary;
});


/***/ }),

/***/ 981282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ FlashSalePromotionBlock; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Shape/index.es.js
var index_es = __webpack_require__(425336);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/FlashSaleFilled.es.js
var FlashSaleFilled_es = __webpack_require__(576862);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/FireFlashsaleColored.es.js
var FireFlashsaleColored_es = __webpack_require__(767535);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Row.es.js + 1 modules
var Row_es = __webpack_require__(408797);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var Typography_index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/BaseProps/index.es.js
var BaseProps_index_es = __webpack_require__(640128);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/CountdownTime/CountdownTime.es.js
var CountdownTime_es = __webpack_require__(883578);
;// CONCATENATED MODULE: ./assets/nl-desktop-flash-sale-background.svg
/* harmony default export */ var nl_desktop_flash_sale_background = ("data:image/svg+xml;base64,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");
;// CONCATENATED MODULE: ./assets/nl-mobile-flashsale-background.svg
/* harmony default export */ var nl_mobile_flashsale_background = ("data:image/svg+xml;base64,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");
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ./components/ProgressBar.tsx
var ProgressBar = __webpack_require__(514605);
;// CONCATENATED MODULE: ./components/FlashSalePromotion.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  text-transform: uppercase;\n  flex: 1 0 auto;\n  font-size: 15px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  font-size: 15px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










const FlashSalePromotion = (_param)=>{
    var { endAt , message , progress  } = _param, rest = _objectWithoutProperties(_param, [
        "endAt",
        "message",
        "progress"
    ]);
    const { isMobile  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, _objectSpreadProps(_objectSpread({
        background: isMobile ? nl_mobile_flashsale_background : nl_desktop_flash_sale_background
    }, rest), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                align: "middle",
                justify: "space-between",
                margin: [
                    "s4",
                    "s0"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FlashSaleFilled_es/* FlashSaleFilled */.R, {
                                size: 24,
                                color: "#FFA940"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCaption, {
                                weight: "bold",
                                color: "white",
                                marginLeft: "s4",
                                children: "Flashsale"
                            })
                        ]
                    }),
                    endAt && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                        align: "baseline",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_index_es/* Caption */.YS, {
                                weight: "regular",
                                color: "white",
                                level: 1,
                                children: [
                                    (0,i18n.t)("Kết th\xfac sau"),
                                    ": "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCountDownTime, {
                                level: 2,
                                endAt: typeof endAt === "string" || typeof endAt === "number" ? new Date(endAt) : endAt,
                                renderDaysCountdownText: (duration)=>(0,i18n.t)("{{DurationDays}} ng\xe0y", {
                                        DurationDays: duration.days
                                    }),
                                weight: "bold",
                                marginLeft: "s4"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_es/* Row */.X, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressBar/* ProgressBar */.k, {
                    barHeight: 24,
                    progress: progress,
                    barColor: "#FA700C26",
                    backgroundColor: "white",
                    justify: progress === 100 ? "center" : "start",
                    barContent: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                        marginLeft: "s4",
                        align: "middle",
                        style: {
                            zIndex: 100,
                            textTransform: "uppercase"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FireFlashsaleColored_es/* FireFlashsaleColored */.L, {
                                size: 20,
                                z: 2
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Caption */.YS, {
                                level: 1,
                                weight: "medium",
                                color: "#FA541C",
                                marginLeft: "s4",
                                children: message
                            })
                        ]
                    })
                })
            })
        ]
    }));
};
const Wrapper = emotion_styled_browser_esm["default"].div((param)=>{
    let { background , theme  } = param;
    return '\n    background: url("'.concat(background, '");\n    padding: ').concat(theme === null || theme === void 0 ? void 0 : theme.spacing.s4, " ").concat(theme === null || theme === void 0 ? void 0 : theme.spacing.s8, ";\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center;\n");
}, BaseProps_index_es/* CommonStyles */.F, "border-radius: 10px;");
const StyledCaption = (0,emotion_styled_browser_esm["default"])(Typography_index_es/* Caption */.YS)(_templateObject());
const StyledCountDownTime = (0,emotion_styled_browser_esm["default"])(CountdownTime_es/* CountdownTime */.v)(_templateObject1());

// EXTERNAL MODULE: ./contexts/ProductDetailContext.tsx + 3 modules
var ProductDetailContext = __webpack_require__(534924);
;// CONCATENATED MODULE: ./modules/product-detail/shared/FlashSalePromotionBlock.tsx





const FlashSalePromotionBlock = ()=>{
    const { product , showFlashSale  } = (0,ProductDetailContext/* useProductDetailState */.W)();
    const { isMobile  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { total , used , endAt  } = (product === null || product === void 0 ? void 0 : product.flashSale) || {};
    const remain = typeof used === "number" && typeof total === "number" ? Math.min(total - used, (product === null || product === void 0 ? void 0 : product.totalAvailable) || Number.MAX_SAFE_INTEGER) : 0;
    const message = total === used || remain <= 0 ? (0,i18n.t)("Ch\xe1y h\xe0ng") : (0,i18n.t)("C\xf2n lại {{remain}}", {
        remain: remain
    });
    if (showFlashSale && typeof used === "number" && typeof total === "number") return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, {
        paddingTop: isMobile ? "s8" : "s0",
        padding: [
            "s8",
            "s0"
        ],
        backgroundColor: "white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlashSalePromotion, {
            progress: Math.min(100 * (used / total), 100),
            message: message,
            endAt: endAt
        })
    });
    else return null;
};


/***/ }),

/***/ 768439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ ProductProviderInfo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(348855);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(212951);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(325710);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(534924);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(684443);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(634655);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  border-radius: 4px;\n  background-color: #f5f5f5;\n  padding-left: 8px;\n  padding-right: 8px;\n  padding-top: 2px;\n  padding-bottom: 2px;\n  max-width: 105px;\n  font-size: 13px;\n  color: black;\n  font-weight: 400;\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  border-radius: 0;\n  border-top: 1px dashed;\n  border-bottom: 1px dashed;\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






const ProductProviderInfo = ()=>{
    const { product  } = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useProductDetailState */ .W)();
    const { isMobile , hideProviderInfo  } = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)();
    const { colors  } = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_4__/* .useTheme */ .F)();
    const provider = (product === null || product === void 0 ? void 0 : product.provider) || {
        name: "",
        logo: "",
        id: ""
    };
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    if (hideProviderInfo) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_5__/* .Shape */ .b, {
        backgroundColor: "white",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledSellerCard, {
            padding: isMobile ? "s8" : "s16",
            style: {
                borderColor: colors.border
            },
            name: provider.name,
            slogan: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ViewProduct, {
                onClick: ()=>router.replace("/cua-hang/".concat(provider.id, "?pageTitle=").concat(provider.name)),
                children: (0,i18n__WEBPACK_IMPORTED_MODULE_6__.t)("Xem sản phẩm")
            }),
            avatar: {
                src: provider.logo || ""
            },
            link: {
                href: "/cua-hang/".concat(provider.id, "?pageTitle=").concat(provider.name)
            },
            showSlogan: true
        })
    });
};
const ViewProduct = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__["default"].div(_templateObject());
const StyledSellerCard = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__["default"])(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_8__/* .SellerCard */ .S)(_templateObject1());


/***/ }),

/***/ 795021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ TierPromotions; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/InforOutlined.es.js
var InforOutlined_es = __webpack_require__(628382);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Shape/index.es.js
var index_es = __webpack_require__(425336);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var Typography_index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Row.es.js + 1 modules
var Row_es = __webpack_require__(408797);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Col.es.js
var Col_es = __webpack_require__(212808);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-mobile-virtual-190eca22c0/1/packages/ds-mobile/dist/components/ButtonChevron/ButtonChevron.es.js
var ButtonChevron_es = __webpack_require__(781662);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/Modal.es.js + 1 modules
var Modal_es = __webpack_require__(411213);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/ModalBody.es.js
var ModalBody_es = __webpack_require__(309110);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-mobile-virtual-190eca22c0/1/packages/ds-mobile/dist/components/BottomSheet/BottomSheet.es.js
var BottomSheet_es = __webpack_require__(811495);
;// CONCATENATED MODULE: ./assets/promotion-badge.svg
/* harmony default export */ var promotion_badge = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzM0OTBfNTgwMykiPgo8cGF0aCBkPSJNLTEuNzE2NjFlLTA1IDkuOTk5OTlDLTEuNzE2NjFlLTA1IDguNjQ0OTkgMC41OTQ5ODIgNy4zNjY2NSAxLjYwNDE1IDYuNTYzMzJDMS40ODc0OCA1LjIxMTY1IDEuOTcwODIgMy44ODc0OSAyLjkyOTE1IDIuOTI4MzJDMy44ODc0OCAxLjk3MDgyIDUuMjA4MzIgMS40ODU4MiA2LjQ5MzMyIDEuNjMyNDlDOC4xNzE2NSAtMC40OTc1MTQgMTEuNzk3NSAtMC41Mzc1MTQgMTMuNDM2NiAxLjYwMzMyQzE2LjEzMDggMS4yODMzMiAxOC43MjE2IDMuODE5OTkgMTguMzY2NiA2LjQ5MzMyQzIwLjQ5NjYgOC4xNzE2NSAyMC41Mzc1IDExLjc5NzUgMTguMzk1OCAxMy40Mzc1QzE4LjUxMjUgMTQuNzg5MiAxOC4wMjkxIDE2LjExMzMgMTcuMDcwOCAxNy4wNzI1QzE2LjExMjUgMTguMDMgMTQuNzkgMTguNTE1IDEzLjUwNjYgMTguMzY4M0MxMS44MjgzIDIwLjQ5ODMgOC4yMDI0OCAyMC41MzgzIDYuNTYzMzIgMTguMzk3NUM1LjIxMzMyIDE4LjUxMzMgMy44ODgzMiAxOC4wMzE3IDIuOTI5MTUgMTcuMDcyNUMxLjk3MTY1IDE2LjExNDIgMS40ODgzMiAxNC43ODkyIDEuNjMzMzIgMTMuNTA4M0MwLjU5NDk4MiAxMi42MzUgLTEuNzE2NjFlLTA1IDExLjM1NjcgLTEuNzE2NjFlLTA1IDEwLjAwMTdWOS45OTk5OVpNMTMuMzMzMyA3LjQ5OTk5QzEzLjMyODMgNi40MDk5OSAxMS42NzE2IDYuNDA5OTkgMTEuNjY2NiA3LjQ5OTk5QzExLjY3MTYgOC41ODk5OSAxMy4zMjgzIDguNTg5OTkgMTMuMzMzMyA3LjQ5OTk5Wk0xMC45NzMzIDEyLjk2MjVDMTEuMjMgMTMuMzQ4MyAxMS43NTA4IDEzLjQ0NjcgMTIuMTI5MSAxMy4xOTMzQzEyLjUxMjUgMTIuOTM4MyAxMi42MTU4IDEyLjQyMDggMTIuMzYgMTIuMDM3NUw5LjAyNjY1IDcuMDM3NDlDOC43NzE2NSA2LjY1NDk5IDguMjU0OTggNi41NDk5OSA3Ljg3MDgyIDYuODA2NjVDNy40ODc0OCA3LjA2MTY1IDcuMzg0MTUgNy41NzkxNSA3LjYzOTk4IDcuOTYyNDlMMTAuOTczMyAxMi45NjI1Wk03LjQ5OTk4IDEzLjMzMzNDOC41ODk5OCAxMy4zMjgzIDguNTg5OTggMTEuNjcxNyA3LjQ5OTk4IDExLjY2NjdDNi40MDk5OCAxMS42NzE3IDYuNDA5OTggMTMuMzI4MyA3LjQ5OTk4IDEzLjMzMzNaIiBmaWxsPSIjMDA5NzNDIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMzQ5MF81ODAzIj4KPHJlY3Qgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJtYXRyaXgoLTEgMCAwIDEgMjAgMCkiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K");
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
// EXTERNAL MODULE: ./modules/cart/utils/index.ts
var utils = __webpack_require__(739069);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
;// CONCATENATED MODULE: ./modules/product-detail/shared/TierPromotion.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  cursor: pointer;\n  color: #00973c;\n  font-weight: 500;\n\n  &:hover {\n    color: #006b2a;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 24px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 0;\n  max-height: 600px;\n  overflow-y: auto;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  margin: 0;\n  padding-left: 0; // remove default padding of ul\n  margin-left: 2rem;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}








const MAX_DISPLAY_DESCRIPTIONS = 3;
const TierPromotions = (props)=>{
    const { productPromotions , isApplicableWithCombo =true , maxLinesBeforeEllipsis =1 , isCustomerTierPromotions =false ,  } = props;
    const { isMobile , epicOmni1643  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { 0: showDetail , 1: setShowDetail  } = (0,react.useState)(false);
    // all promotions of an item (not being grouped)
    const allItemPromotions = (0,utils/* flattenPromotionsFromPromotionGroups */.Ou)(productPromotions);
    // all tier descriptions of an item (not being grouped)
    const allItemTierDescriptions = (0,react.useMemo)(()=>{
        const flattedTierDescriptions = !!allItemPromotions.length ? allItemPromotions.reduce((previousTierDescriptions, currentPromotion)=>[
                ...previousTierDescriptions,
                ...currentPromotion.tierDescriptions || [], 
            ], []) : [];
        return flattedTierDescriptions.length > 0 ? flattedTierDescriptions.filter((tierDesc)=>!!tierDesc.descriptions.length) : [];
    }, [
        allItemPromotions
    ]);
    const allItemHightLightDescriptions = (0,react.useMemo)(()=>{
        const flattedHightLightDescriptions = !!allItemPromotions.length ? allItemPromotions.reduce((previousHightLightDescriptions, currentPromotion)=>{
            var ref;
            return !!((ref = currentPromotion.highlightedDescriptions) === null || ref === void 0 ? void 0 : ref.length) ? [
                ...previousHightLightDescriptions,
                ...currentPromotion.highlightedDescriptions, 
            ] : previousHightLightDescriptions;
        }, []) : [];
        return flattedHightLightDescriptions;
    }, [
        allItemPromotions
    ]);
    const allItemCustomerTierDescription = (0,react.useMemo)(()=>{
        const flattedCustomerTierDescriptions = !!allItemPromotions.length ? allItemPromotions.reduce((previousTierDescriptions, currentPromotion)=>[
                ...previousTierDescriptions,
                ...currentPromotion.customerTierDescriptions || [], 
            ], []) : [];
        return flattedCustomerTierDescriptions;
    }, [
        allItemPromotions
    ]);
    // displaying tier descriptions limit to MAX_DISPLAY_DESCRIPTIONS
    const displayTierDescriptions = (0,react.useMemo)(()=>{
        return allItemTierDescriptions.length > MAX_DISPLAY_DESCRIPTIONS ? allItemTierDescriptions.slice(0, MAX_DISPLAY_DESCRIPTIONS) : allItemTierDescriptions;
    }, [
        allItemTierDescriptions
    ]);
    const handleCloseDetailModal = ()=>setShowDetail(false);
    const renderDetailContent = ()=>{
        return allItemTierDescriptions.map((tierDesc, index)=>{
            var ref;
            return ((ref = tierDesc.descriptions) === null || ref === void 0 ? void 0 : ref.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(TierDescList, {
                marginBottom: index !== allItemTierDescriptions.length - 1 ? "8px" : "0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                        children: tierDesc.title
                    }),
                    ":",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    tierDesc.descriptions.map((desc, subIndex)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: desc
                        }, "".concat(index, "-").concat(subIndex)))
                ]
            }, index) : null;
        });
    };
    if (!allItemTierDescriptions.length && !isCustomerTierPromotions || isCustomerTierPromotions && !allItemCustomerTierDescription.length) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !!displayTierDescriptions.length || !!allItemCustomerTierDescription.length && isCustomerTierPromotions ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, {
                padding: [
                    "s8",
                    "s0"
                ],
                backgroundColor: "white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PromotionBox, {
                    borderRadius: "m",
                    padding: "s8",
                    border: epicOmni1643 ? undefined : "1px solid #00973c33",
                    epicOmni1643: epicOmni1643,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLabel, {
                            epicOmni1643: epicOmni1643,
                            children: [
                                !epicOmni1643 && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: promotion_badge,
                                    alt: "Promotion Badge"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Caption */.YS, {
                                    level: 1,
                                    weight: "medium",
                                    color: epicOmni1643 ? "white" : undefined,
                                    children: isCustomerTierPromotions ? (0,i18n.t)("Ưu đ\xe3i kh\xe1ch h\xe0ng th\xe0nh vi\xean") : (0,i18n.t)("Mua nhiều th\xeam Ưu đ\xe3i")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, {
                            marginTop: "s28",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledUl, {
                                children: isCustomerTierPromotions ? allItemCustomerTierDescription.map((tierDesc, index)=>!!tierDesc.description ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_index_es/* Body */.uT, {
                                            weight: "regular",
                                            line: maxLinesBeforeEllipsis,
                                            color: "#000",
                                            marginBottom: "s4",
                                            children: [
                                                tierDesc.title,
                                                " ",
                                                tierDesc.description
                                            ]
                                        }, index)
                                    }) : null) : displayTierDescriptions.map((tierDesc, index)=>{
                                    var ref, ref1;
                                    return ((ref = tierDesc.descriptions) === null || ref === void 0 ? void 0 : ref.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_index_es/* Body */.uT, {
                                            weight: "regular",
                                            line: maxLinesBeforeEllipsis,
                                            color: "#000",
                                            marginBottom: "s4",
                                            children: [
                                                tierDesc.title,
                                                " ",
                                                (ref1 = tierDesc.descriptions) === null || ref1 === void 0 ? void 0 : ref1.join(" & ")
                                            ]
                                        }, index)
                                    }) : null;
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                            justify: !isApplicableWithCombo || !!allItemHightLightDescriptions.length ? "space-between" : "end",
                            align: "bottom",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                                    children: [
                                        !isApplicableWithCombo && (0,i18n.t)("Kh\xf4ng \xe1p dụng c\xf9ng combo"),
                                        !!allItemHightLightDescriptions.length && allItemHightLightDescriptions[0], 
                                    ].filter(Boolean).map((message, index)=>{
                                        const color = epicOmni1643 ? "warning" : "#00973C";
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                                            align: "middle",
                                            justify: "start",
                                            children: [
                                                !epicOmni1643 && /*#__PURE__*/ (0,jsx_runtime.jsx)(InforOutlined_es/* InforOutlined */.l, {
                                                    size: 16,
                                                    color: color
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                                                    color: color,
                                                    marginLeft: "s4",
                                                    children: message
                                                })
                                            ]
                                        }, index);
                                    })
                                }),
                                !isCustomerTierPromotions && !epicOmni1643 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDetailButton, {
                                        onClick: ()=>setShowDetail(true),
                                        children: (0,i18n.t)("Xem chi tiết")
                                    })
                                })
                            ]
                        }),
                        epicOmni1643 && !isCustomerTierPromotions && /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_es/* Row */.X, {
                            justify: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonChevron_es/* ButtonChevron */.y, {
                                direction: "down",
                                style: {
                                    border: "none"
                                },
                                onClick: ()=>setShowDetail(true),
                                children: (0,i18n.t)("Xem th\xeam KM kh\xe1c")
                            })
                        })
                    ]
                })
            }) : null,
            !!showDetail && (!!isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBottomSheet, {
                show: showDetail,
                title: (0,i18n.t)("Chi tiết khuyến m\xe3i"),
                closeBottomSheet: handleCloseDetailModal,
                backdropClicked: handleCloseDetailModal,
                contentHeight: "500px",
                zIndex: 1060,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, {
                    padding: [
                        "s4",
                        "s16"
                    ],
                    children: renderDetailContent()
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledModal, {
                width: 600,
                visible: showDetail,
                title: (0,i18n.t)("Chi tiết khuyến m\xe3i"),
                centeredTitle: true,
                okText: "",
                cancelText: (0,i18n.t)("Đ\xf3ng"),
                onCancel: handleCloseDetailModal,
                onClose: handleCloseDetailModal,
                showCloseIcon: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledModalBody, {
                    children: renderDetailContent()
                })
            }))
        ]
    });
};
/* ---------------- Styled ---------------- */ const PromotionBox = (0,emotion_styled_browser_esm["default"])(index_es/* Shape */.b)((param)=>{
    let { epicOmni1643 , theme  } = param;
    return "\n  position: relative;\n  background: \n    ".concat(!epicOmni1643 ? "linear-gradient(180deg,rgba(0, 151, 60, 0.1) 0%,rgba(0, 151, 60, 0) 100%)" : theme.colors.secondary50, ";\n");
});
const StyledLabel = emotion_styled_browser_esm["default"].div((param)=>{
    let { epicOmni1643 , theme  } = param;
    return "\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: max-content;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  border-top-left-radius: 0.5rem;\n  border-bottom-right-radius: 0.5rem;\n  padding: 0.25rem 1rem 0.25rem 1rem;\n  background: ".concat(!epicOmni1643 ? "linear-gradient(90deg, #fae14c 59.21%, #00973c 100%)" : theme.colors.primary, ";\n");
});
const StyledDetailButton = (0,emotion_styled_browser_esm["default"])(Typography_index_es/* Body */.uT)(_templateObject());
const StyledModal = (0,emotion_styled_browser_esm["default"])(Modal_es/* Modal */.u)(_templateObject1());
const StyledModalBody = (0,emotion_styled_browser_esm["default"])(ModalBody_es/* ModalBody */.f)(_templateObject2());
const TierDescList = emotion_styled_browser_esm["default"].ul((param)=>{
    let { marginBottom  } = param;
    return "\n  list-style-position: inside;\n  margin-bottom: ".concat(marginBottom, ";\n");
});
const StyledBottomSheet = (0,emotion_styled_browser_esm["default"])(BottomSheet_es/* BottomSheet */.R)(_templateObject3());
const StyledUl = emotion_styled_browser_esm["default"].ul(_templateObject4());


/***/ })

}]);